<template>
		<div class="content home-page">
		<Header></Header>
      <div class="" @click="back" style="text-align: left;;align-items: center;justify-content: center;">
        <img style="width: 1.5rem;margin-left: 1rem" src="../../static/images/back.png" />
      </div>
			<div class="info crfff">
        <div class="fs50 mt50 ac">{{$t('Billing')}}</div>
        <div class="quan">{{$t('billingTips')}}</div>
        <div class="list mt30">
          <div class="bill-li" v-for="(item,index) in list">
            <div class="lf flex">
              <div>{{$t('ID')}} : {{item.id}}</div>
              <div class="lf">
                <img width="40" style="height: auto;" src="../../static/images/fen2.png" />
                <strong>{{item.score}}</strong>
              </div>
            </div>
            <div class="lf mt30 flex">
              <div class="">{{item.memo}}</div>
              <div class="date">{{item.createtime}}</div>
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       list:[],
      }
    },
	created(){
		this.getHome();
	},
  methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
			that.$api.post('/api/user/bill',null,r =>{
				that.$parent.returnCode(r,function(){
          that.list = r.data
					that.$parent.loadModal(false);
				});

			})

		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/billing.vue